import CheckoutViewSFC from "./CheckoutView.vue";
export const CheckoutView = CheckoutViewSFC;
